import { Loader2, ClipboardList, Mail } from 'lucide-react';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

export function DelegatedPlansDialog({ open, onOpenChange, loading, dispatches, onRemind, onToggle }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[85vh] overflow-y-auto" data-testid="cap-dispatches-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ClipboardList className="h-4 w-4 text-cyan-600" /> Delegated succession plans
          </DialogTitle>
          <DialogDescription className="sr-only">Audit trail of emailed succession briefs and their follow-up status.</DialogDescription>
        </DialogHeader>
        {loading ? (
          <div className="py-12 flex justify-center"><Loader2 className="h-6 w-6 animate-spin text-cyan-600" /></div>
        ) : dispatches.length === 0 ? (
          <div className="py-10 text-center text-sm text-slate-400">No briefs have been emailed yet.</div>
        ) : (
          <div className="space-y-2" data-testid="cap-dispatches-list">
            {dispatches.map(d => (
              <div key={d.id} className={`flex items-center gap-3 rounded-lg border p-3 ${d.stale ? 'border-red-200 bg-red-50/40' : 'border-slate-200'}`} data-testid={`cap-dispatch-${d.id}`}>
                <div className={`h-2 w-2 rounded-full shrink-0 ${d.status === 'open' ? (d.stale ? 'bg-red-500' : 'bg-amber-400') : 'bg-emerald-500'}`} />
                <div className="min-w-0 flex-1">
                  <p className="text-sm font-semibold text-slate-800 truncate">{d.target_label || d.title}</p>
                  <p className="text-[11px] text-slate-500 truncate">
                    → {d.recipient_email} · {d.sent_by_name || 'Unknown'} · {d.sent_at ? new Date(d.sent_at).toLocaleDateString() : ''}
                    {d.status === 'open' && typeof d.days_open === 'number' ? ` · ${d.days_open}d open` : ''}
                  </p>
                </div>
                {d.stale && (
                  <Badge variant="outline" className="text-[10px] shrink-0 bg-red-100 text-red-700 border-red-200" data-testid={`cap-dispatch-stale-${d.id}`}>Stale</Badge>
                )}
                <Badge variant="outline" className={`text-[10px] shrink-0 ${d.status === 'open' ? 'bg-amber-50 text-amber-700 border-amber-200' : 'bg-emerald-50 text-emerald-700 border-emerald-200'}`}>
                  {d.status === 'open' ? 'Open' : 'Followed up'}
                </Badge>
                {d.stale && (
                  <Button size="sm" variant="outline" className="h-7 text-[11px] shrink-0 border-red-200 text-red-700 hover:bg-red-50 gap-1"
                    onClick={() => onRemind(d)} data-testid={`cap-dispatch-remind-${d.id}`}>
                    <Mail className="h-3 w-3" /> Remind
                  </Button>
                )}
                <Button size="sm" variant="outline" className="h-7 text-[11px] shrink-0"
                  onClick={() => onToggle(d)} data-testid={`cap-dispatch-toggle-${d.id}`}>
                  {d.status === 'open' ? 'Mark followed up' : 'Reopen'}
                </Button>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
